"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionService = void 0;
var axios_1 = __importDefault(require("axios"));
var AxiosErrorParser_1 = require("Errors/AxiosErrorParser");
var SubscriptionService = (function () {
    function SubscriptionService(apiBaseUrl, account, telemetry, environment, internalSlack, user, $log) {
        var _this = this;
        this.apiBaseUrl = apiBaseUrl;
        this.account = account;
        this.telemetry = telemetry;
        this.environment = environment;
        this.internalSlack = internalSlack;
        this.user = user;
        this.$log = $log;
        this.pingSlack = function (feedback) {
            var feedbackMessage = "Closing account feedback from ".concat(_this.user.email, "\n") +
                "The account was on a ".concat(_this.account.plan.displayName, " plan\n");
            feedback.forEach(function (response) {
                feedbackMessage += "".concat(response.question, "\n").concat(response.answer, "\n");
            });
            if (_this.environment === "production") {
                _this.internalSlack.ping(feedbackMessage, "#feedback");
            }
            else {
                _this.$log.log("Closing account feedback", feedbackMessage);
            }
        };
    }
    SubscriptionService.prototype.cancelSubscription = function (feedback) {
        return __awaiter(this, void 0, Promise, function () {
            var url, plan, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.apiBaseUrl, "/accounts/").concat(this.account._id, "/payment/subscription/cancel");
                        plan = this.account.plan;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.post(url, { feedback: feedback }, { withCredentials: true })];
                    case 2:
                        response = _a.sent();
                        this.telemetry.trackOnly("Subscription Cancelled", {
                            stripe_plan_name_old: plan.internalName,
                            stripe_plan_interval_old: plan.unit,
                            stripe_plan_price_old: plan.price,
                            stripe_plan_seats_number_old: this.account.additionalSeats,
                            stripe_plan_seats_price_old: plan.seats.price,
                            subscriber_tool_switching_to: feedback[0].answer,
                            subscriber_tool_switching_to_reason: feedback[1].answer,
                        });
                        this.pingSlack(feedback);
                        return [2, response.data.message];
                    case 3:
                        err_1 = _a.sent();
                        throw new Error((0, AxiosErrorParser_1.getErrorMessage)(err_1));
                    case 4: return [2];
                }
            });
        });
    };
    SubscriptionService.prototype.addAttribution = function (oldTool, reason) {
        this.telemetry.trackOnly("Subscription Started", {
            stripe_customer_id: this.account.stripe && this.account.stripe.customerToken,
        }, {
            blockNonMarketing: true,
        });
        this.telemetry.update({
            subscriber_tool_switching_from: oldTool,
            subscriber_tool_switching_from_reason: reason,
        });
    };
    return SubscriptionService;
}());
exports.SubscriptionService = SubscriptionService;
